"use client";
import React from "react";

import Header from "@/components/Header";
import Footer from "@/components/Footer";

export type BaseProps = {
  children: React.ReactNode;
  isLoading?: boolean;
};

const Base = ({ children }: BaseProps) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default Base;
